/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    Button,
    ModalActions,
    ButtonGroup,
    Icon,
    DisplayHtmlContent,
    Accordion,
    AccordionItem,
    StyledModal,
    AccordionHeading,
    AccordionContent,
} from 'sarsaparilla';
import { ContentProps } from '../props';

export default class FAQModal extends Component {
    static defaultProps = {
        faqs: [],
    };

    static propTypes = {
        faqs: PropTypes.arrayOf(ContentProps),
    };

    state = {
        isOpen: false,
    };

    toggleModal = () => this.setState(({ isOpen }) => ({ isOpen: !isOpen }));

    render() {
        const { isOpen } = this.state;
        const { faqs } = this.props;

        if (!faqs.length) return null;

        return (
            <section>
                <Button
                    appearance="link"
                    onClick={this.toggleModal}
                    iconBeforeElement={<Icon iconName="help-outline" />}
                    className="activitypass-faq-button-wrap"
                >
                    Frequently Asked Questions
                </Button>
                <StyledModal
                    isOpen={isOpen}
                    onRequestClose={this.toggleModal}
                    role="complementary"
                    heading="Frequently Asked Questions"
                >
                    <div className="rec-modal-content-wrap">
                        <div className="activitypass-contents-wrapper">
                            <Accordion
                                headingLevel={2}
                                appearance="h1"
                                id="with-children"
                            >
                                {faqs.map(({ title, paragraphs = [] }, i) => (
                                    <AccordionItem
                                        className="activitypass-faq"
                                        key={`section-${i}`}
                                    >
                                        {!!title && (
                                            <AccordionHeading>{title}</AccordionHeading>
                                        )}
                                        <AccordionContent>
                                            {paragraphs.map((item, index) => (
                                                <div key={`paragraph-${index}`}>
                                                    <DisplayHtmlContent html={item} />
                                                </div>
                                            ))}
                                        </AccordionContent>
                                    </AccordionItem>
                                ))}
                            </Accordion>
                        </div>
                    </div>
                    <ModalActions>
                        <ButtonGroup isFullWidthOnMobile={false} isStretchedToFit>
                            <Button onClick={this.toggleModal}>Close</Button>
                        </ButtonGroup>
                    </ModalActions>
                </StyledModal>
            </section>
        );
    }
}

// cspell:ignore activitypass
